var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.394 11.925c.244-.194.606-.012.606.294V25c0 1.656-1.344 3-3 3H3c-1.656 0-3-1.344-3-3V12.225c0-.313.356-.488.606-.294 1.4 1.087 3.256 2.469 9.631 7.1 1.319.963 3.544 2.988 5.763 2.975 2.231.019 4.5-2.05 5.769-2.975 6.375-4.631 8.225-6.019 9.625-7.106zM16 20c-1.45.025-3.537-1.825-4.588-2.588-8.294-6.019-8.925-6.55-10.837-8.044A1.507 1.507 0 0 1 0 8.187V6.999c0-1.656 1.344-3 3-3h26c1.656 0 3 1.344 3 3v1.188c0 .463-.213.9-.575 1.181-1.912 1.5-2.544 2.025-10.837 8.044-1.05.762-3.137 2.613-4.588 2.588z"}));
}

Envelope.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Envelope;

Envelope.default = Envelope;
